export const validators = {

  emailFormat: (error: string) => ({
    format: {
      func: (val?: string) => !!val && /^[a-zA-Z0-9][-a-zA-Z0-9._]+@([-a-zA-Z0-9]+\.)+[a-zA-Z]{2,5}$/.test(val),
      error
    }
  }),

  phoneFormat: (error: string) => ({
    format: {
      func: (val?: string) => !!val && /^\+(?:[0-9]\s?){6,14}[0-9]$/.test(val),
      error
    }
  }),

  minLength: (min: number, error: string) => ({
    length: {
      func: (val?: string) => !!val && val?.trim().length >= min,
      error
    }
  })

}
